import helper from './Helper';
import template from './Templates';
import animation from './Animation';

/** ----------------------------------------
    Narrow Casting Tickets
 ---------------------------------------- */

export class Tickets {

    constructor() {
        this.refresh = 15000;
        this.scrollSpeed = 1400;
        this.introDuration = 2500;
        this.screen = {};
        this.current = 0;
        this.dataClone;
        this.ticketPerScreen = 7;
        this.initialized = false;
        // this._setTheme();
        this.screensaver = false;
    }

    /** ----------------------------------------
         Set Data
     ---------------------------------------- */

    set data(data) {
        this.screen = data;
        if (!this.dataClone) {
            this.dataClone = data.feed.slice(0);
        }
        if (!this.initialized) {
            this.init();
        }
    }

     /** ----------------------------------------
         Set Theme
     ---------------------------------------- */

     _setTheme() {
        helper.randomTheme();
    }

    /** ----------------------------------------
        Cycle
     ---------------------------------------- */

     _cycle(data) {
        let $this = this;
        let ticket = document.querySelector('.narrowcasting-ticket');
        let ticketHeight = 0;
        let marginTop = 20;
        let borderBottom = 1;
        const introEl = document.body.querySelector('.screen-intro');
        if (ticket) {
            ticketHeight = document.querySelector('.narrowcasting-ticket').offsetHeight + marginTop; // should add borderBottom also, but works better without (?)
        }

        // TODO: check if tickets fit screen
        setInterval(function() {
            let screen = document.querySelector('.screen__slide');
            let firstTicket = document.querySelector('.narrowcasting-ticket');
            let allTickets = document.querySelectorAll('.narrowcasting-ticket');

            // if tickets dont fit on screen - cycle through
            if ($this.screen.feed.length > $this.ticketPerScreen) {
                animation.scrollStagger(allTickets, ticketHeight, $this.scrollSpeed);
                animation.fadeOut(firstTicket, $this.scrollSpeed);

                setTimeout(function() {
                    $this.dataClone.splice(0, 1);
                    $this.dataClone.push( $this.screen.feed[ $this.current ] )
                    $this._displayAll();
                    $this.current++;
                    if ($this.dataClone[$this.current] == 'undefined' || $this.dataClone[$this.current] == 'null') {
                        $this.current = 0;
                    }
                    if ($this.current >= $this.screen.feed.length) {
                        $this.current = 0;
                    }
                }, $this.scrollSpeed)
            // else just display movies and remove if necessary
            } else {
                // if movie has to be removed (already past the initial time)
                if (($this.dataClone.length > $this.screen.feed.length)) {
                    animation.scrollStagger(allTickets, ticketHeight, $this.scrollSpeed);
                    animation.fadeOut(firstTicket, $this.scrollSpeed);
                    setTimeout(function() {
                        $this.dataClone.splice(0, 1);
                        $this._displayAll();
                        $this.dataClone = $this.screen.feed;
                    }, $this.scrollSpeed);
                // else just watch for updates
                } else {
                    $this.dataClone = $this.screen.feed;
                    $this._displayAll();
                }

                // if no tickets, show screensaver screen
                if ($this.screen.feed.length <= 0) {
                    if (!$this.screensaver) {
                        animation.fadeIn(introEl, 1000, $this.introDuration);
                        $this.screensaver = true;
                    }
                } else {
                    if ($this.screensaver) {
                        animation.fadeOut(introEl, 1000, $this.introDuration);
                        $this.screensaver = false;
                    }
                }
            }

        }, $this.refresh);

    }
    /** ----------------------------------------
        Display
     ---------------------------------------- */

    _displayAll () {

        let $this = this;
            
        let data = $this.dataClone;

        let children = ``;
        data.forEach(ticket => {
            children += template.ticket(ticket);
        });
        let parent = `<div class="screen__slide" style="padding: 0 30px; overflow: hidden;">${children}</div>`;
        helper.empty();
        helper.insert(parent);
        
    }

    /** ----------------------------------------
        Intro
     ---------------------------------------- */

    _intro() {
        let $this = this;
        const introEl = document.body.querySelector('.screen-intro');
        const logoEl = document.body.querySelector('.screen-intro__logo svg');
        animation.fadeOut(introEl, 1000, $this.introDuration);
        animation.zoomIn(logoEl, $this.introDuration * 2 , 0, 1.1)
        helper.initFadeIn();
        helper.schedule($this.introDuration, function() {
            // INIT CYCLE
            $this._displayAll();
            $this._cycle($this.dataClone);
            $this.initialized = true;
        })
    }

    /** ----------------------------------------
        Initialize
     ---------------------------------------- */

    init() {
        this._intro();

        // refresh after 1 hr (only if connected)
        helper.schedule(3600000, function() {
            if (navigator.onLine) {
                location.reload();
            }
        })
    }
}